import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const RevenueIcon = ({
  width = "14",
  height = "14",
  color = "#797979",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.75 3.5H12.25V10.5H1.75V3.5ZM7 5.25C7.46413 5.25 7.90925 5.43437 8.23744 5.76256C8.56563 6.09075 8.75 6.53587 8.75 7C8.75 7.46413 8.56563 7.90925 8.23744 8.23744C7.90925 8.56563 7.46413 8.75 7 8.75C6.53587 8.75 6.09075 8.56563 5.76256 8.23744C5.43437 7.90925 5.25 7.46413 5.25 7C5.25 6.53587 5.43437 6.09075 5.76256 5.76256C6.09075 5.43437 6.53587 5.25 7 5.25ZM4.08333 4.66667C4.08333 4.97609 3.96042 5.27283 3.74162 5.49162C3.52283 5.71042 3.22609 5.83333 2.91667 5.83333V8.16667C3.22609 8.16667 3.52283 8.28958 3.74162 8.50838C3.96042 8.72717 4.08333 9.02391 4.08333 9.33333H9.91667C9.91667 9.02391 10.0396 8.72717 10.2584 8.50838C10.4772 8.28958 10.7739 8.16667 11.0833 8.16667V5.83333C10.7739 5.83333 10.4772 5.71042 10.2584 5.49162C10.0396 5.27283 9.91667 4.97609 9.91667 4.66667H4.08333Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
